import { useState, useEffect } from "react";
import {deleteAttachmentFromCase} from 'actions/homeowner/caseforms';

const useDeleteAttachments = ({
  controlNumber,
  dispatch,
  callback,
}) => {
  const [files, setFiles] = useState([]);
  useEffect(
    () => {
      if(files.length !== 0)
      {
        files.map(({name}) => dispatch(deleteAttachmentFromCase(
          controlNumber,
          name,
          callback,
        )));
        setFiles([]);
      }
    },
    [files]
  );
  return [setFiles];
};

export default useDeleteAttachments;